import { AmplienceImage } from '@/types/amplience';

/**
 * @deprecated use getAmplienceImageUrl instead
 */
export const getImageUrl = (image: AmplienceImage, width?: number) => {
  let widthParam = '';
  if (width) {
    widthParam = `&w=${width}`;
  }
  return `https://${image.image.defaultHost}/i/${image.image.endpoint}/${encodeURIComponent(image.image.name)}?fmt=auto${widthParam}`;
};

export const getAmplienceImageUrl = (
  image: AmplienceImage['image'] | string,
  options?: {
    quality?: number;
    aspectRatio?: `${number}:${number}`;
    width?: number;
    height?: number;
    resize?: { edge: 'w' | 'h' | 'smallest' | 'largest'; length: number };
  }
): URL => {
  const url = new URL(
    typeof image === 'string'
      ? image
      : `https://${image.defaultHost}/i/${image.endpoint}/${encodeURIComponent(image.name)}`
  );

  url.searchParams.set('fmt', 'auto');
  url.searchParams.set('qlt', String(options?.quality ?? 'default'));

  if (options?.aspectRatio) {
    url.searchParams.set('sm', 'aspect');
    url.searchParams.set('aspect', options?.aspectRatio);
  }

  if (options?.width) {
    url.searchParams.set('w', options.width.toString());
  }

  if (options?.height) {
    url.searchParams.set('h', options.height.toString());
  }
  if (options?.resize) {
    url.searchParams.set('sm', 'edge');
    url.searchParams.set('resize.edge', options.resize.edge);
    url.searchParams.set('resize.edge.length', options.resize.length.toString());
  }

  return url;
};

export const getFallbackImage = (
  fallbackImg: AmplienceImage | AmplienceImage[] | undefined
): AmplienceImage | undefined => (Array.isArray(fallbackImg) ? fallbackImg[0] : fallbackImg);

// Hint: Consider using AmplienceResponsiveImage component instead of this function for srcset support
export const getAssetUrlByName = (
  name: string,
  amplienceMediaBaseUrl: string,
  width: number,
  height?: number
) => {
  const url = new URL(`${amplienceMediaBaseUrl}/i/spreadshirt/${name}?fmt=auto`);
  if (width) url.searchParams.append('w', width.toString());
  if (height) url.searchParams.append('h', height.toString());

  return url.toString();
};
